var exports = {
  "k": "x112a1f60--b376f4--container",
  "p": "x112a1f60--b376f4--price-info",
};

module.exports = exports;
